<ui-dropdown-input
    [options]="locationOptions"
    [width]="width"
    [(ngModel)]="innerModel"
    (ngModelChange)="selected($event)"
></ui-dropdown-input>
